module.exports = __webpack_public_path__ + "static/IMG-20200723-WA0009-f4bd1aff04ce17f890a5ec95fb0738bf.jpg";